<template>
    <div class="generic-modal-container" v-if="!hidden" @click="bgClicked" :class="{
        opened: !hidden,
        'bg-clip-padding bg-gray-50 backdrop-filter bg-opacity-50 px-2': !hidden,
        opaque: isOpaque
    }">
        <div
            class="generic-fs-modal bg-white p-0 md:p-2 -mt-2 border-gray-200 border rounded-lg max-w-full w-full md:w-4/5">
            <div class="overflow-y-scroll h-[83vh] md:h-[65vh] " style="">
                <fs :ref="'fs'" :show-options="false" v-if="filesystemId" :filesystem-id="filesystemId"
                    :path="filesystemPath"></fs>
            </div>
        </div>
    </div>
</template>

<script>

import {PackageNew} from "@models";

export default {
    components: {},
    props: {
        isOpaque: true,
    },
    data() {
        return {
            hidden: true,
            filesystemId: '',
            filesystemPath: '',
        }
    },
    computed: {},
    methods: {
        closeModal() {
            this.hidden = true;
        },
        openModal($filesystemId, $filesystemPath) {
            this.filesystemId = $filesystemId;
            this.filesystemPath = $filesystemPath;
            window.Bus.emit('close-all-slideovers');
            this.hidden = false;
        },
        upload($filesystemId, $filesystemPath) {
            this.openModal($filesystemId, $filesystemPath);
            let upload = () => {
                if (!this.$refs.fs.$refs.fsNodes) {
                    setTimeout(upload, 50)
                } else {
                    this.$refs.fs.$refs.fsNodes.manualUpload()
                }
            }
            setTimeout(upload, 50)
        },
        bgClicked(e) {
            if (e.target.classList.contains('generic-modal-container')) {
                this.closeModal();
            }
        },
        resizeListener(e) {
            if (window.innerWidth <= 830) {
                if (!this.hidden) {
                    this.closeModal();
                }
            }
        },
    },
    async mounted() {
        window.Bus.on('close-all-slideovers', (reference) => {
            this.closeModal()
        })
        window.addEventListener('resize', this.resizeListener)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeListener)
    }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/setup';

.generic-modal-container {
    position: absolute;
    top: 0px;
    left: 0px;

    &.opened {
        position: absolute;
        min-height: 100vh;
        width: 100vw;
        z-index: 100000;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        @include desktop() {
            &.opaque {
                background-color: rgba(255, 255, 255, 1);
            }
        }
    }
}

.generic-fs-modal {
    div.actions {
        text-align: left;
        margin-top: 30px;

        a, input[type="submit"] {
            padding: 0.7em 0.7em 0.8em;
            text-decoration: none;
            color: #fff;
            border-radius: $standardBorderRadius;
        }

        input[type="submit"] {
            background-color: $green;
        }

        a {
            background-color: #999;
        }

        a.success {
            background-color: $green;
        }

        @include desktop() {
            float: right;
            text-align: right;
        }
    }
}
</style>
